const getAll = `/login_activities`

const get = (id) => {
  return `/login_activities/${id}`
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const LoginActivitiesService = {
  getAll,
  get,
  toRow,
  toPaginate
}

export default LoginActivitiesService
